<template>
  <div class="portlet light">
    <div class="ss-titre">
        <span class="font-red-sunglo uppercase bold">Changer les conditions générales de vente :</span>
    </div>
    <div class="portlet-body">
      <v-ckeditor name="cgv" title="" v-model="newCgv"></v-ckeditor>
      <button type="submit" class="btn green" @click="send">Mettre à jour</button>
    </div>
  </div>
</template>

<script>
export default {

  name: 'OfficeCgvForm',
  props:{
    cgv: {
      type: Object,
      default: () => {
        return {}
      }
    },
    office: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      newCgv: this.cgv.content
    }
  },
  methods: {
    async send() {
      //await axios.put(`/office/${this.office.id}`, this.newCgv)
      console.log(this.newCgv);
      await axios.put("cgv/"+this.office.id,{'cgv':this.newCgv})

      this.$snotify.success('Les cgv ont bien été mises à jour')
    }
  }
};
</script>

<style lang="css" scoped>
</style>
